import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
var whitespaceSharedStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  word-wrap: break-word;\n  white-space: pre-wrap;\n"], ["\n  word-wrap: break-word;\n  white-space: pre-wrap;\n"])));
export { whitespaceSharedStyles };
var templateObject_1;
//# sourceMappingURL=whitespace.js.map